// extracted by mini-css-extract-plugin
module.exports = {"socialMediaRow":"styles_socialMediaRow__SqEcf"};